module.exports = __webpack_public_path__ + "img/robot1lb3.6ed32b1b.png";